import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import GuestMarketplaceHeader from './GuestMarketplaceHeader';
import MarketPlaceFilters from './MarketPlaceFilters';
import { useGuestMarketplace } from '../../context/guestMarketplaceContext';
import './guestMarketplace.scss';

const GuestMarketplaceShell: FC = () => {
  const { activeFilters, setActiveFilters, listingProductCount, guestCartItemCount } = useGuestMarketplace();

  return (
    <div className="guest-marketplace">
      <GuestMarketplaceHeader cartItemCount={guestCartItemCount} />
      <div className="guest-marketplace__body">
        <aside className="guest-marketplace__sidebar">
          <MarketPlaceFilters
            variant="sidebar"
            isOpen
            onClose={() => undefined}
            initial={activeFilters}
            onApply={setActiveFilters}
            productCount={listingProductCount}
          />
        </aside>
        <div className="guest-marketplace__main">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default GuestMarketplaceShell;
